import 'core-js/stable';
import 'regenerator-runtime/runtime';

import React from 'react';
import ReactDOM from 'react-dom';
import ProjectHealthCheck from '../project_health_check';

const element = document.getElementById('project-health-check-mountpoint');
document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(
    <ProjectHealthCheck />,
    element,
  );
});
